<template>
  <div class="w-full">
    <Header :account="account"></Header>
  </div>
</template>

<script>
import Header from './components/Header'

export default{
  components: {
    Header
  },

  async created () {

    try {
      this.account = (await window.axios.get(`/accounts/subaccounts/${this.$route.params.id}`)).data
    } catch (error) {
      //Handle error
    }

  },
  mounted () {
    this.$parent.setupTabsBar()
  },
  data () {
    return {
      account: {
      }
    }
  }
}
</script>
